import React, { useMemo } from 'react';
import { convertBytesUnits } from '../../../../../../utils/convertBytesUnit';
import './bar.scss';

interface BarProps {
    value: number;
    total: number;
    max: number;
    isBarDisplay: boolean;
    bgColor: string;
}

export const Bar: React.FC<BarProps> = ({ value, total, max, isBarDisplay, bgColor }) => {

    const { percent, barWidth } = useMemo(() => {
        const percentVal = (value / total) * 100;
        const barWidthVal = (value / max) * 100;
        return { percent: percentVal, barWidth: barWidthVal };
    }, [value, total, max]);

    const bytesUnit = useMemo(() => convertBytesUnits(value), [value]);

    return (
        <div className="bar-container">
            <div className="bar-chart-wrapper" style={{width: `100%`}} >
                { isBarDisplay && <div className="bar-percent" style={{width: `${barWidth}%`, background: bgColor}} />}
            </div>
            <div className="numbers-wrapper">
                <div className="percent">{percent.toFixed(2)}%</div>
                <div className="circle" />
                <div className="bytes">
                    <span className="value">{bytesUnit.value}</span>
                    <span className="unit">{bytesUnit.unitName}</span>
                </div>
            </div>
        </div>
    );
};
